/* Formulaire de contact / devis Market Spas (11/09/2026) — routage e-mail par pays, formats code postal / téléphone,
   état de chargement, événement Meta « Lead » et envoi du lead au CRM. Logique métier reprise de ms-devis-form-assets. */
(function () {
  'use strict';
  var CONFIG = {
    'France':     { mail: 'fr', cpLength: 5, cpPattern: '[0-9]{5}', cpPlaceholder: '75001', telPlaceholder: '06 12 34 56 78' },
    'Belgique':   { mail: 'eu', cpLength: 4, cpPattern: '[0-9]{4}', cpPlaceholder: '1000', telPlaceholder: '0470 12 34 56' },
    'Luxembourg': { mail: 'eu', cpLength: 4, cpPattern: '[0-9]{4}', cpPlaceholder: '1234', telPlaceholder: '621 123 456' },
    'Suisse':     { mail: 'eu', cpLength: 4, cpPattern: '[0-9]{4}', cpPlaceholder: '1000', telPlaceholder: '079 123 45 67' },
    'Pays-Bas':   { mail: 'eu', cpLength: 7, cpPattern: '[0-9]{4} ?[A-Za-z]{2}', cpPlaceholder: '1234 AB', telPlaceholder: '06 12345678' },
    'Allemagne':  { mail: 'eu', cpLength: 5, cpPattern: '[0-9]{5}', cpPlaceholder: '10115', telPlaceholder: '0151 23456789' },
    'Espagne':    { mail: 'es', cpLength: 5, cpPattern: '[0-9]{5}', cpPlaceholder: '11379', telPlaceholder: '612 345 678' }
  };
  var CRM_URL = 'https://marketspas.pro/api/leads/inbound';

  function init(root) {
    if (root.__msContact) return;
    root.__msContact = true;
    var form = root.querySelector('form');
    if (!form) return;
    var mails = {
      fr: root.getAttribute('data-mail-fr') || 'france@marketspas.com',
      eu: root.getAttribute('data-mail-eu') || 'info@marketspas.com',
      es: root.getAttribute('data-mail-es') || 'es@spas-wellis.com'
    };
    var byId = function (id) { return form.querySelector('#' + id); };
    var pays = byId('pays'), dest = byId('email_destination'), cp = byId('code_postal'), tel = byId('telephone');

    function applyCountry(reset) {
      var c = pays && CONFIG[pays.value];
      if (!c) return;
      if (dest) dest.value = mails[c.mail];
      if (cp) {
        cp.setAttribute('maxlength', c.cpLength);
        cp.setAttribute('pattern', c.cpPattern);
        cp.setAttribute('placeholder', c.cpPlaceholder);
        if (reset) cp.value = '';
      }
      if (tel) {
        tel.setAttribute('placeholder', c.telPlaceholder);
        if (reset) tel.value = '';
      }
    }
    if (pays) {
      pays.addEventListener('change', function () { applyCountry(true); });
      applyCountry(false); /* pays pré-sélectionné par Liquid : routage appliqué sans vider les champs */
    }
    if (cp) cp.addEventListener('input', function () {
      var p = pays ? pays.value : '';
      if (p === 'Pays-Bas') { this.value = this.value.toUpperCase().slice(0, 7); return; }
      var max = CONFIG[p] ? CONFIG[p].cpLength : 5;
      this.value = this.value.replace(/\D/g, '').slice(0, max);
    });
    if (tel) tel.addEventListener('input', function () {
      var val = this.value.replace(/\D/g, ''), p = pays ? pays.value : '';
      if (!val.length) return;
      if (p === 'France') { var g = val.match(/.{1,2}/g); if (g) this.value = g.join(' ').slice(0, 14); }
      else if (p === 'Belgique') { this.value = val.length <= 4 ? val : val.slice(0, 4) + ' ' + val.slice(4).match(/.{1,2}/g).join(' ').slice(0, 11); }
      else if (p === 'Luxembourg') { this.value = val.length <= 3 ? val : val.slice(0, 3) + ' ' + val.slice(3).match(/.{1,3}/g).join(' ').slice(0, 11); }
      else { this.value = val.slice(0, 15); }
    });

    /* Un champ invalide au moment de l'envoi : la classe active le style d'erreur des champs (voir ms-contact-form.css) */
    form.addEventListener('invalid', function () { form.classList.add('is-submitted'); }, true);

    var sent = false;
    function submitButton() { return form.querySelector('.ms-contact__submit'); }
    form.addEventListener('submit', function (e) {
      if (sent) { e.preventDefault(); return; }
      sent = true;
      setTimeout(function () { sent = false; }, 8000);
      var btn = submitButton();
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      if (typeof window.fbq === 'function') {
        try { window.fbq('track', 'Lead', { content_name: 'devis_spa', content_category: 'formulaire_devis', value: 0, currency: 'EUR' }); } catch (err) {}
      }
      var v = function (id) { var el = byId(id); return el ? el.value : ''; };
      var checked = form.querySelector('input[name="contact[type_projet]"]:checked');
      var projet = checked ? checked.value : '';
      var prenom = v('prenom'), nom = v('nom'), email = v('email'), telephone = v('telephone'), codePostal = v('code_postal'),
          ville = v('ville'), paysValue = v('pays'), budget = v('budget'), msg = v('message');
      if (!(email || prenom) || typeof window.fetch !== 'function') return;
      try {
        window.fetch(CRM_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            source: 'SHOPIFY_FORM', firstName: prenom, lastName: nom, email: email, phone: telephone, postalCode: codePostal, city: ville, country: paysValue,
            subject: projet ? 'Devis ' + projet : 'Demande de devis depuis le site',
            message: [projet ? 'Projet : ' + projet : '', budget ? 'Budget : ' + budget : '', msg ? 'Message : ' + msg : ''].filter(Boolean).join('\n'),
            budget: budget, projectType: projet,
            metadata: { shopifyPage: window.location.href, submittedAt: new Date().toISOString() }
          })
        }).then(function (r) { return r.json(); }).then(function (d) { if (window.console) console.log('[Market Spas] Lead enregistré :', d); })
          .catch(function (err) { if (window.console) console.warn('[Market Spas] Erreur envoi lead (non bloquant) :', err); });
      } catch (err) {}
    });
    /* Retour arrière (bfcache) : le bouton retrouve son état normal */
    window.addEventListener('pageshow', function () {
      var btn = submitButton();
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      sent = false;
    });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ms-contact]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
